import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import {
  EventCheckIn,
  EventCheckInScan,
  EventForm,
  EventManage,
  EventsList,
  OrganizerRequestForm,
  OrganizerStats,
} from '../../screens/menu/events'

export type EventsStackParamList = {
  EventsList: undefined
  EventCreate: undefined
  EventManage: { eventId: string }
  EventEdit: { eventId: string }
  EventCheckIn: { eventId: string }
  EventCheckInScan: { eventId: string }
  OrganizerRequest: undefined
  OrganizerStats: undefined
}

const Stack = createNativeStackNavigator<EventsStackParamList>()

/** Events POC: "Mes événements" and the organizer screens. */
const EventsStackNavigator: React.FC = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="EventsList" component={EventsList} />
    <Stack.Screen name="EventCreate" component={EventForm} />
    <Stack.Screen name="EventManage" component={EventManage} />
    <Stack.Screen name="EventEdit" component={EventForm} />
    <Stack.Screen name="EventCheckIn" component={EventCheckIn} />
    <Stack.Screen name="EventCheckInScan" component={EventCheckInScan} />
    <Stack.Screen name="OrganizerRequest" component={OrganizerRequestForm} />
    <Stack.Screen name="OrganizerStats" component={OrganizerStats} />
  </Stack.Navigator>
)

export default EventsStackNavigator
